"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customerOrderApi = require("@/api/customerOrderApi");
var _cardCouponApi = require("@/api/cardCouponApi");
var _shopIntegralApi = require("@/api/shopIntegralApi");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var defaultFormData = function defaultFormData() {
  return {
    id: '',
    activityName: '',
    goodsType: '',
    activityTime: [],
    cashPointRate: '',
    cardRuleList: [{
      cardTypes: [],
      cardPointRate: ''
    }],
    /** 0 全选适用分销客户，1 部分选择（须选客户） */
    applyCustomerType: 0,
    customerScope: []
  };
};
var _default = exports.default = {
  name: 'PointsActivityOperate',
  data: function data() {
    var _this = this;
    return {
      currentStep: 0,
      mode: 'create',
      detailLoading: false,
      submitLoading: false,
      detailRequestToken: 0,
      formData: defaultFormData(),
      customerOptions: [],
      customerLoading: false,
      cardOptions: [],
      cardLoading: false,
      /** 活动时间：禁选过去日期 + 禁选当前时刻之前（打开面板时刷新 selectableRange） */
      activityTimePickerOptions: {},
      /** 范围选择器选日期时的默认时刻（用户可再改结束时分秒，不再强制改回 23:59:59） */
      activityTimeDefaultRange: ['00:00:00', '23:59:59'],
      rules: {
        activityName: [{
          validator: function validator(rule, value, callback) {
            if (value == null || String(value).trim() === '') {
              callback(new Error('请输入活动名称'));
            } else {
              callback();
            }
          },
          trigger: ['blur', 'change']
        }],
        goodsType: [{
          required: true,
          message: '请选择商品类型',
          trigger: 'change'
        }],
        activityTime: [{
          type: 'array',
          required: true,
          message: '请选择活动时间',
          trigger: 'change'
        }, {
          validator: function validator(rule, value, callback) {
            if (!value || !Array.isArray(value) || value.length < 2 || !value[0] || !value[1]) {
              callback(new Error('请选择完整的活动开始与结束时间'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        cashPointRate: [{
          validator: function validator(rule, value, callback) {
            if (value === '' || value == null || String(value).trim() === '') {
              callback(new Error('请输入'));
              return;
            }
            if (!_this.isValidGivePercentIntStr(value)) {
              callback(new Error('须为 1～100000 的整数（不超过 6 位）'));
              return;
            }
            callback();
          },
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  computed: {
    isView: function isView() {
      return this.mode === 'view';
    },
    pointsOperatePerms: function pointsOperatePerms() {
      return this.mode === 'edit' && this.formData.id ? ['admin:shopintegral:activity:updateGiveActivity'] : ['admin:shopintegral:activity:addGiveActivity'];
    }
  },
  watch: {
    /** 与 AppMain :key="$route.name" 搭配时，同 name 复用实例不会走 created，需随路由刷新详情 */
    '$route': {
      immediate: true,
      handler: function handler(to) {
        if (to.name !== 'pointsActivityOperate') return;
        this.initPageState();
      }
    }
  },
  created: function created() {
    this.resetActivityTimePickerOptions();
    this.searchCustomerOptions('');
    this.searchCardOptions('');
  },
  methods: {
    resetActivityTimePickerOptions: function resetActivityTimePickerOptions() {
      var fmt = function fmt(d) {
        var p = function p(n) {
          return String(n).padStart(2, '0');
        };
        return "".concat(d.getFullYear(), "-").concat(p(d.getMonth() + 1), "-").concat(p(d.getDate()), " ").concat(p(d.getHours()), ":").concat(p(d.getMinutes()), ":").concat(p(d.getSeconds()));
      };
      var now = new Date();
      var end = new Date(2099, 11, 31, 23, 59, 59);
      this.activityTimePickerOptions = {
        disabledDate: function disabledDate(time) {
          var dayStart = new Date(time.getFullYear(), time.getMonth(), time.getDate(), 0, 0, 0, 0);
          var todayStart = new Date();
          todayStart.setHours(0, 0, 0, 0);
          return dayStart.getTime() < todayStart.getTime();
        },
        selectableRange: "".concat(fmt(now), " - ").concat(fmt(end))
      };
    },
    onActivityTimePickerVisible: function onActivityTimePickerVisible(visible) {
      if (visible && this.mode !== 'edit') {
        this.resetActivityTimePickerOptions();
      }
    },
    initPageState: function initPageState() {
      this.mode = this.$route.params.mode || 'create';
      var routeId = this.$route.params.id || '';
      this.resetOperateFormState();
      if (routeId) {
        this.loadActivityDetail(routeId);
      }
    },
    resetOperateFormState: function resetOperateFormState() {
      var _this2 = this;
      this.currentStep = 0;
      this.formData = defaultFormData();
      this.$nextTick(function () {
        if (_this2.$refs.baseForm) {
          _this2.$refs.baseForm.clearValidate();
        }
      });
    },
    mergeCustomerOptionsFromDetail: function mergeCustomerOptionsFromDetail(data) {
      var byId = new Map((this.customerOptions || []).map(function (x) {
        return [Number(x.customerId), x];
      }));
      var namedList = data.applyCustomerList || data.applyCustomerVOList || data.customerList || data.applyCustomers;
      var idsFromRules = data.applyCustomerIds;
      if (!idsFromRules || !idsFromRules.length) {
        var rs = data.rules || [];
        for (var i = 0; i < rs.length; i++) {
          if (rs[i] && Array.isArray(rs[i].applyCustomerIds) && rs[i].applyCustomerIds.length) {
            idsFromRules = rs[i].applyCustomerIds;
            break;
          }
        }
      }
      if (Array.isArray(namedList) && namedList.length) {
        namedList.forEach(function (row) {
          var cid = Number(row.customerId != null ? row.customerId : row.id);
          if (!Number.isNaN(cid)) {
            var name = row.appName || row.name || row.customerName;
            byId.set(cid, {
              customerId: cid,
              appName: name ? String(name) : "\u5BA2\u6237 ".concat(cid)
            });
          }
        });
      } else if (Array.isArray(idsFromRules)) {
        idsFromRules.forEach(function (cid) {
          var id = Number(cid);
          if (!Number.isNaN(id) && !byId.has(id)) {
            byId.set(id, {
              customerId: id,
              appName: "\u5BA2\u6237 ".concat(id)
            });
          }
        });
      }
      this.customerOptions = Array.from(byId.values());
    },
    applyActivityDetailToForm: function applyActivityDetailToForm(data) {
      if (!data) return;
      var fd = defaultFormData();
      fd.activityName = data.activityName != null ? String(data.activityName) : '';
      fd.goodsType = data.productType != null ? String(data.productType) : '';
      var rules = Array.isArray(data.rules) ? data.rules : [];
      var startTime = data.startTime;
      var endTime = data.endTime;
      if (!startTime && rules.length) {
        var r = rules.find(function (x) {
          return x && x.startTime;
        });
        if (r) startTime = r.startTime;
      }
      if (startTime && endTime) {
        fd.activityTime = this.normalizeSameDayActivityTime([startTime, endTime]);
      }
      fd.id = data.id != null ? String(data.id) : '';
      var cashRule = rules.find(function (r) {
        return Number(r.costType) === 1;
      });
      if (cashRule && cashRule.givePercent != null) {
        fd.cashPointRate = String(cashRule.givePercent);
      }
      var cardRules = rules.filter(function (r) {
        return Number(r.costType) === 2;
      });
      if (cardRules.length) {
        /** 回显：单条带 cardIds[] 直接一行；多条同比例+同适用客户（旧接口多条 cardId）合并为一行多选 */
        var applySig = function applySig(r) {
          var t = r.applyCustomerType != null ? Number(r.applyCustomerType) : -1;
          var ids = Array.isArray(r.applyCustomerIds) ? _toConsumableArray(r.applyCustomerIds).map(function (x) {
            return Number(x);
          }).filter(function (x) {
            return !Number.isNaN(x);
          }).sort(function (a, b) {
            return a - b;
          }).join(',') : '';
          return "".concat(t, "|").concat(ids);
        };
        var merged = new Map();
        cardRules.forEach(function (r) {
          var pct = r.givePercent != null ? String(r.givePercent) : '';
          var k = "".concat(pct, "|").concat(applySig(r));
          var ids = [];
          if (Array.isArray(r.cardIds) && r.cardIds.length) {
            ids = r.cardIds.map(function (x) {
              return Number(x);
            }).filter(function (x) {
              return !Number.isNaN(x);
            });
          } else if (r.cardId != null && r.cardId !== '') {
            var n = Number(r.cardId);
            if (!Number.isNaN(n)) ids = [n];
          }
          if (!merged.has(k)) {
            merged.set(k, {
              cardTypes: [],
              cardPointRate: pct
            });
          }
          var row = merged.get(k);
          ids.forEach(function (id) {
            if (!row.cardTypes.includes(id)) row.cardTypes.push(id);
          });
        });
        var rows = Array.from(merged.values()).filter(function (row) {
          return row.cardTypes.length > 0;
        });
        fd.cardRuleList = rows.length ? rows : [{
          cardTypes: [],
          cardPointRate: ''
        }];
      }
      var firstWithCustomers = rules.find(function (r) {
        return Array.isArray(r.applyCustomerIds) && r.applyCustomerIds.length;
      });
      var refRule = cashRule || rules[0];
      if (refRule != null && refRule.applyCustomerType != null && refRule.applyCustomerType !== '') {
        fd.applyCustomerType = Number(refRule.applyCustomerType);
      } else if (firstWithCustomers) {
        fd.applyCustomerType = 1;
      } else {
        fd.applyCustomerType = 0;
      }
      if (Number(fd.applyCustomerType) === 1 && firstWithCustomers) {
        fd.customerScope = firstWithCustomers.applyCustomerIds.map(function (x) {
          return Number(x);
        });
      }
      this.formData = fd;
      this.mergeCustomerOptionsFromDetail(data);
    },
    loadActivityDetail: function () {
      var _loadActivityDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(routeId) {
        var token, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              token = ++this.detailRequestToken;
              this.detailLoading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _shopIntegralApi.shopIntegralGiveActivityInfoApi)(routeId);
            case 2:
              data = _context.v;
              if (!(token !== this.detailRequestToken)) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              this.applyActivityDetailToForm(data);
              if (this.mode === 'copy') {
                this.formData.id = '';
                this.formData.activityName = '';
                this.formData.goodsType = '';
                this.formData.activityTime = [];
              }
              _context.n = 4;
              return this.searchCardOptions('');
            case 4:
              _context.p = 4;
              if (token === this.detailRequestToken) {
                this.detailLoading = false;
              }
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1,, 4, 5]]);
      }));
      function loadActivityDetail(_x) {
        return _loadActivityDetail.apply(this, arguments);
      }
      return loadActivityDetail;
    }(),
    searchCustomerOptions: function () {
      var _searchCustomerOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(keyword) {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.customerLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _customerOrderApi.companyappAutoListApi)({
                keyword: keyword
              });
            case 2:
              res = _context2.v;
              this.customerOptions = res || [];
            case 3:
              _context2.p = 3;
              this.customerLoading = false;
              return _context2.f(3);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1,, 3, 4]]);
      }));
      function searchCustomerOptions(_x2) {
        return _searchCustomerOptions.apply(this, arguments);
      }
      return searchCustomerOptions;
    }(),
    searchCardOptions: function () {
      var _searchCardOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(keyword) {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.cardLoading = true;
              _context3.p = 1;
              _context3.n = 2;
              return (0, _cardCouponApi.getFucardList)(keyword);
            case 2:
              res = _context3.v;
              this.cardOptions = res || [];
            case 3:
              _context3.p = 3;
              this.cardLoading = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1,, 3, 4]]);
      }));
      function searchCardOptions(_x3) {
        return _searchCardOptions.apply(this, arguments);
      }
      return searchCardOptions;
    }(),
    /** 行内已选卡 id 列表（兼容旧数据 cardType） */normalizeRuleCardTypes: function normalizeRuleCardTypes(rule) {
      if (!rule) return [];
      if (Array.isArray(rule.cardTypes) && rule.cardTypes.length) {
        return rule.cardTypes.map(function (x) {
          return Number(x);
        }).filter(function (x) {
          return !Number.isNaN(x);
        });
      }
      if (Array.isArray(rule.cardIds) && rule.cardIds.length) {
        return rule.cardIds.map(function (x) {
          return Number(x);
        }).filter(function (x) {
          return !Number.isNaN(x);
        });
      }
      if (rule.cardType !== '' && rule.cardType != null) {
        var n = Number(rule.cardType);
        return Number.isNaN(n) ? [] : [n];
      }
      return [];
    },
    /** 福卡类文案：接 -卡片id：id（多选时用顿号拼接） */cardRuleLeadLabel: function cardRuleLeadLabel(rule) {
      var ids = this.normalizeRuleCardTypes(rule);
      var suffix = ids.length ? ids.join('、') : '';
      return suffix ? "\u7528\u6237\u4F7F\u7528\u5361 ID\uFF1A".concat(suffix) : '用户使用卡 ID：';
    },
    cardOptionLabel: function cardOptionLabel(item) {
      var name = item && item.card_name != null ? String(item.card_name) : '';
      var id = item && item.id != null ? item.id : '';
      return "".concat(name, " ID\uFF1A").concat(id);
    },
    /** 其它行已选的福卡不在本行下拉中展示；本行当前选中项仍保留以便展示与清空 */getCardOptionsForRow: function getCardOptionsForRow(rowIndex) {
      var _this3 = this;
      var list = this.cardOptions || [];
      var rules = this.formData.cardRuleList || [];
      return list.filter(function (item) {
        var id = item.id != null ? String(item.id) : '';
        var pickedElsewhere = rules.some(function (r, idx) {
          if (idx === rowIndex) return false;
          return _this3.normalizeRuleCardTypes(r).some(function (cid) {
            return String(cid) === id;
          });
        });
        if (pickedElsewhere) return false;
        return true;
      });
    },
    handleCardChange: function handleCardChange() {
      this.searchCardOptions('');
    },
    addCardRule: function addCardRule() {
      if (this.formData.cardRuleList.length >= 10) {
        this.$message.warning('最多添加10条用卡规则');
        return;
      }
      this.formData.cardRuleList.push({
        cardTypes: [],
        cardPointRate: ''
      });
    },
    removeCardRule: function removeCardRule(index) {
      this.formData.cardRuleList.splice(index, 1);
    },
    /** 返积分比例（现金/用卡）：1～100000 的整数（位数不超过 6 位） */isValidGivePercentIntStr: function isValidGivePercentIntStr(val) {
      if (val === '' || val === null || val === undefined) return false;
      var n = Number(String(val).trim());
      return !Number.isNaN(n) && Number.isInteger(n) && n >= 1 && n <= 100000;
    },
    /** 第二步：用卡规则、适用客户（第一步字段由 el-form rules + validate 校验） */validateStep1: function validateStep1() {
      for (var i = 0; i < this.formData.cardRuleList.length; i++) {
        var r = this.formData.cardRuleList[i];
        var hasCard = this.normalizeRuleCardTypes(r).length > 0;
        var rateStr = r.cardPointRate;
        var hasRate = rateStr !== '' && rateStr != null && String(rateStr).trim() !== '';
        if (hasCard !== hasRate) {
          this.$message.warning("\u7B2C ".concat(i + 1, " \u6761\u7528\u5361\u89C4\u5219\u987B\u540C\u65F6\u9009\u62E9\u5361\u7247\u5E76\u586B\u5199\u6BD4\u4F8B"));
          return false;
        }
        if (hasRate && !this.isValidGivePercentIntStr(rateStr)) {
          this.$message.warning("\u7B2C ".concat(i + 1, " \u6761\u7528\u5361\u89C4\u5219\u7684\u79EF\u5206\u6BD4\u4F8B\u987B\u4E3A 1\uFF5E100000 \u7684\u6574\u6570\uFF08\u4E0D\u8D85\u8FC7 6 \u4F4D\uFF09"));
          return false;
        }
      }
      if (Number(this.formData.applyCustomerType) === 1) {
        if (!this.formData.customerScope || !this.formData.customerScope.length) {
          this.$message.warning('请选择适用分销客户');
          return false;
        }
      }
      return true;
    },
    nextStep: function nextStep() {
      var _this4 = this;
      if (this.isView) {
        if (this.currentStep < 1) this.currentStep += 1;
        return;
      }
      if (this.currentStep !== 0) return;
      this.$refs.baseForm.validate(function (valid) {
        if (!valid) return;
        _this4.currentStep += 1;
      });
    },
    prevStep: function prevStep() {
      if (this.currentStep > 0) this.currentStep -= 1;
    },
    /**
     * 返积分比例是否视为「有填写」：与提交校验一致须为 ≥1 的整数；0 多为 el-input-number 空态占位，不算已填
     */
    isMeaningfulGiveRateField: function isMeaningfulGiveRateField(val) {
      if (val === '' || val == null) return false;
      var n = Number(String(val).trim());
      return !Number.isNaN(n) && Number.isInteger(n) && n >= 1;
    },
    /** 是否有已填写内容（有则取消需二次确认） */hasPointsOperateFormFilled: function hasPointsOperateFormFilled() {
      if (this.currentStep > 0) return true;
      var fd = this.formData;
      if ((fd.activityName || '').trim() !== '') return true;
      if (fd.goodsType !== '' && fd.goodsType != null) return true;
      var at = fd.activityTime || [];
      if (at.length >= 2 && at[0] && at[1]) return true;
      var list = fd.cardRuleList || [];
      if (list.length > 1) return true;
      for (var i = 0; i < list.length; i++) {
        var r = list[i];
        if (this.normalizeRuleCardTypes(r).length) return true;
        if (this.isMeaningfulGiveRateField(r.cardPointRate)) return true;
      }
      if (this.isMeaningfulGiveRateField(fd.cashPointRate)) return true;
      if (fd.customerScope && fd.customerScope.length > 0) return true;
      return false;
    },
    handleReset: function handleReset() {
      var _this5 = this;
      if (this.isView) {
        void this.closeOperateTabAndGoPointsList();
        return;
      }
      if (!this.hasPointsOperateFormFilled()) {
        void this.closeOperateTabAndGoPointsList();
        return;
      }
      this.$confirm('取消后全部数据不保留,是否取消?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return _this5.closeOperateTabAndGoPointsList();
      }).catch(function () {});
    },
    /** 确认取消：关闭当前标签并进入积分获取配置列表 */closeOperateTabAndGoPointsList: function () {
      var _closeOperateTabAndGoPointsList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.$store.dispatch('tagsView/delView', this.$route);
            case 1:
              _context4.n = 2;
              return this.$nextTick();
            case 2:
              _context4.n = 3;
              return this.$router.replace({
                path: '/integral/pointsActivity'
              });
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function closeOperateTabAndGoPointsList() {
        return _closeOperateTabAndGoPointsList.apply(this, arguments);
      }
      return closeOperateTabAndGoPointsList;
    }(),
    onApplyCustomerTypeChange: function onApplyCustomerTypeChange(val) {
      if (Number(val) === 0) {
        this.formData.customerScope = [];
      }
    },
    buildGiveRulesPayload: function buildGiveRulesPayload() {
      var _this6 = this;
      var fd = this.formData;
      var applyCustomerType = Number(fd.applyCustomerType) === 0 ? 0 : 1;
      var customerIds = (fd.customerScope || []).map(function (id) {
        return Number(id);
      });
      var baseApply = {
        applyCustomerType: applyCustomerType,
        applyCustomerIds: applyCustomerType === 1 && customerIds.length ? customerIds : undefined
      };
      var rules = [];
      rules.push(_objectSpread(_objectSpread({}, baseApply), {}, {
        costType: 1,
        givePercent: Number(fd.cashPointRate)
      }));
      (fd.cardRuleList || []).forEach(function (r) {
        var cardIds = _this6.normalizeRuleCardTypes(r);
        var rateStr = r.cardPointRate;
        var hasRate = rateStr !== '' && rateStr != null && String(rateStr).trim() !== '';
        if (cardIds.length && hasRate) {
          rules.push(_objectSpread(_objectSpread({}, baseApply), {}, {
            costType: 2,
            cardIds: cardIds.map(function (id) {
              return Number(id);
            }),
            givePercent: Number(rateStr)
          }));
        }
      });
      return rules;
    },
    /** 仅当同一天且开始与结束完整时间一致时，改为当天 00:00:00～23:59:59 */normalizeSameDayActivityTime: function normalizeSameDayActivityTime(val) {
      if (!val || !Array.isArray(val) || val.length !== 2) return val;
      var a = val[0];
      var b = val[1];
      if (a == null || b == null || a === '' || b === '') return val;
      var sa = String(a).trim();
      var sb = String(b).trim();
      var dateA = sa.length >= 10 ? sa.slice(0, 10) : '';
      var dateB = sb.length >= 10 ? sb.slice(0, 10) : '';
      if (!dateA || !dateB || dateA !== dateB) return val;
      if (sa !== sb) return val;
      return ["".concat(dateA, " 00:00:00"), "".concat(dateB, " 23:59:59")];
    },
    /** 开始、结束均不得早于当前时刻；若结束早于开始则与开始对齐 */clampActivityTimeFromNow: function clampActivityTimeFromNow(val) {
      if (!val || !Array.isArray(val) || val.length !== 2) return val;
      var a = val[0];
      var b = val[1];
      if (a == null || b == null || a === '' || b === '') return val;
      var fmt = function fmt(d) {
        var p = function p(n) {
          return String(n).padStart(2, '0');
        };
        return "".concat(d.getFullYear(), "-").concat(p(d.getMonth() + 1), "-").concat(p(d.getDate()), " ").concat(p(d.getHours()), ":").concat(p(d.getMinutes()), ":").concat(p(d.getSeconds()));
      };
      var parse = function parse(s) {
        return new Date(String(s).replace(/-/g, '/'));
      };
      var now = new Date();
      var da = parse(a);
      var db = parse(b);
      if (Number.isNaN(da.getTime()) || Number.isNaN(db.getTime())) return val;
      if (da.getTime() < now.getTime()) da = new Date(now);
      if (db.getTime() < now.getTime()) db = new Date(now);
      if (da.getTime() > db.getTime()) db = new Date(da);
      return [fmt(da), fmt(db)];
    },
    onActivityTimeChange: function onActivityTimeChange(val) {
      var next = this.normalizeSameDayActivityTime(val);
      next = this.clampActivityTimeFromNow(next);
      this.formData.activityTime = next;
    },
    buildGiveActivityRequest: function buildGiveActivityRequest() {
      var fd = this.formData;
      var range = this.normalizeSameDayActivityTime(fd.activityTime || []) || [];
      if (this.mode !== 'edit') {
        range = this.clampActivityTimeFromNow(range) || [];
      }
      var _range = range,
        _range2 = _slicedToArray(_range, 2),
        startTime = _range2[0],
        endTime = _range2[1];
      var body = {
        activityName: String(fd.activityName || '').trim(),
        startTime: startTime,
        endTime: endTime,
        productType: Number(fd.goodsType),
        rules: this.buildGiveRulesPayload()
      };
      if (this.mode === 'edit' && fd.id) {
        body.id = Number(fd.id);
      }
      return body;
    },
    handleSubmit: function () {
      var _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this7 = this;
        var formOk, isEdit, body;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!this.isView) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              _context5.n = 2;
              return new Promise(function (resolve) {
                _this7.$refs.baseForm.validate(function (valid) {
                  return resolve(valid);
                });
              });
            case 2:
              formOk = _context5.v;
              if (formOk) {
                _context5.n = 3;
                break;
              }
              return _context5.a(2);
            case 3:
              if (this.validateStep1()) {
                _context5.n = 4;
                break;
              }
              return _context5.a(2);
            case 4:
              isEdit = this.mode === 'edit' && this.formData.id;
              this.submitLoading = true;
              _context5.p = 5;
              body = this.buildGiveActivityRequest();
              if (!isEdit) {
                _context5.n = 7;
                break;
              }
              _context5.n = 6;
              return (0, _shopIntegralApi.shopIntegralUpdateGiveActivityApi)(body);
            case 6:
              _context5.n = 8;
              break;
            case 7:
              _context5.n = 8;
              return (0, _shopIntegralApi.shopIntegralAddGiveActivityApi)(body);
            case 8:
              this.$message.success(isEdit ? '保存成功' : '提交成功');
              this.$closeCompletedView();
              this.$router.push({
                path: '/integral/pointsActivity'
              });
            case 9:
              _context5.p = 9;
              this.submitLoading = false;
              return _context5.f(9);
            case 10:
              return _context5.a(2);
          }
        }, _callee5, this, [[5,, 9, 10]]);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }()
  }
};